// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1keT2","buttons":"RemoveExpirationActionButtons_buttons__iv8I6"};